import * as actionTypes from '../actions/actionTypes';
import { message } from 'antd';

let initialState = {
  tmpCurrentStep: 0,
  dataImagesPath: null,
  dataApiPath: null,
  modello:{
    id:null,
    codiceBroker: null,
    currentStep: 0,
    progressivoSimulazione:0,
    numPratica:null,
    datiPratica:{
      importo:2000,
      numeroRate:12,
      assicurazione:false,
      progetto:null,
      tan:0,
      taeg:0,
      rata:0,
      nome:"",
      cognome:"",
      codiceFiscale:"",
      informativaPrivacy: false,
      consensoMkt:null,
      consensoTerzi:null,
      consensoMarketing:null,
      consentFourth:null,
      sesso: "",
      comuneNascita:"",
      provinciaNascita:"",
      dataNascita:"",
      email:"",
      confermaEmail:"",
      cellulare:"",
      telefono:"",
      correntistaCcb:null,
      modalitaVerifica:true,
      iban:"",
      personaEsposta:null,
      cittadinanza:null,
      tipoPermessoSoggiorno:null,
      dataScadenzaSoggiorno:"",
      statoCivile:"",
      abitazione:null,
      importoAffitto:"",
      indirizzoResidenza:"",
      civico:"",
      cap:"",
      comune:null,
      provincia:null,
      tempoResidenza:"",
      indirizzoResidenzaPrecedente:"",
      civicoPrecedente:"",
      capPrecedente:"",
      comunePrecedente:null,
      provinciaPrecedente:null,
      documento:"",
      numeroDocumento:"",
      dataEmissioneDocumento:"",
      comuneEmissione:null,
      provinciaEmissione:null,
      attivita:null,
      occupazioneAutonomo:null,
      occupazioneDipendente:null,
      tipologiaPensione:null,
      dataInizioAttivita:"",
      dataFineAttivita:"",
      settoreAttivita:null,
      tipoContratto:null,
      ragioneSocialeAzienda:"",
      indirizzoResidenzaAzienda:"",
      capAzienda:"",
      comuneAzienda:null,
      provinciaAzienda:null,
      telefonoAzienda:"",
      redditoMensileNetto:"",
      redditoMensilita:"",
      domanda1:null,
      domanda2:null,
      domanda3:null,
      domanda4:null,
      questionarioCompletato:null
    }
  },
  salvaDatiIniziali:{
    esitoControllo:true,
    erroreControllo:false,
    errorMessage:null
  },
  erroreUuid:{
    dati: null
  },
  erroreTokeninbank:{
    dati: null
  },
  errorePreventivo:{
    dati: null
  },
  datiCodiceFiscale:{
    sesso: "",
    comuneNascita:"",
    provinciaNascita:"",
    dataNascita:"",
    errorCode:"",
    errorMessage:"",
  },
  controlloTelefonoCellulare:{
    esitoControllo:true,
    errorMessage:""
  },
  datiIban:{
    banca:"",
    filiale:"",
    correntistaCCB:null,
    errorCode:null,
    errorMessage:""
  },
  controlloCittadinanza:{
    esitoControllo:true,
    errorMessage:""
  },
  controlloResidenza:{
    dati:""
  },
  controlloResidenzaPrecedente:{
    dati:""
  },
  listaProvinceDocumento:{
    dati:""
  },
  listaComuniDocumento:{
    dati:""
  },
  controlloResidenzaAzienda:{
    dati:""
  },
  salvaStep:{
    dati:null
  },
  controlloCap:{
    errorCode:null,
    errorMessage:null
  },
  documenti:{},
  documentiPdf:{
    documentiPreventivatore:null,
    linkSicurezza:null,
    linkCookies:null,
    linkPrivacy:null,
    linkHome:null,
    linkTrasparenza:null,
    linkFiliali:null,
    linkPreventivatore: null,
    documentiTrasparenza:null,
    linkCondizioniPolizza: null,
    docAssicurazione1: null,
    docAssicurazione2: null,
    docAssicurazione3: null,
    docAssicurazione4: null,
    accordions: null
  },
  load:{
    loadingIniziale:false,
    loadingStep:false,
    loadingPreventivo:false,
    loadingCodiceFiscale:false,
    loadingComuni:false,
    loadingProvince:false,
    loadingConferma:false,
    loadingResidenza:false,
    loadingResidenzaPrecedente:false,
    loadingResidenzaAzienda:false,
    loadingUuidGet:false,
    idDocUploaded:false,
    healthDocUploaded:false,
    incomeDocUploaded:false
  },
  datiTokenInBank: null
};

const dataReducer = function (state = initialState, action) {
    switch (action.type) {

      case actionTypes.INIT_DATA_PATH:
        const draftInitPath = {...state};
        if(action.payload.dataImagesPath !== ''){
          draftInitPath.dataImagesPath = action.payload.dataImagesPath;
        }
        if(action.payload.dataApiPath !== ''){
          draftInitPath.dataApiPath = action.payload.dataApiPath;
        }
        draftInitPath.load.loadingIniziale = false;
      return draftInitPath;

      case actionTypes.INIT_DOCUMENTS:
        const draftInitDocuments = {...state};
        draftInitDocuments.documentiPdf.documentiPreventivatore = action.documentiPreventivatore;
        draftInitDocuments.documentiPdf.linkSicurezza = action.linkSicurezza;
        draftInitDocuments.documentiPdf.linkCookies = action.linkCookies;
        draftInitDocuments.documentiPdf.linkPrivacy = action.linkPrivacy;
        draftInitDocuments.documentiPdf.linkHome = action.linkHome;
        draftInitDocuments.documentiPdf.linkPreventivatore = action.linkPreventivatore;
        draftInitDocuments.documentiPdf.linkInformativa = action.linkInformativa;
        draftInitDocuments.documentiPdf.linkTrasparenza = action.linkTrasparenza;
        draftInitDocuments.documentiPdf.linkFiliali = action.linkFiliali;
        draftInitDocuments.documentiPdf.linkCondizioniPolizza = action.linkCondizioniPolizza;
        draftInitDocuments.documentiPdf.docAssicurazione1 = action.docAssicurazione1;
        draftInitDocuments.documentiPdf.docAssicurazione2 = action.docAssicurazione2;
        draftInitDocuments.documentiPdf.docAssicurazione3 = action.docAssicurazione3;
        draftInitDocuments.documentiPdf.docAssicurazione4 = action.docAssicurazione4;
        draftInitDocuments.documentiPdf.accordions = action.accordions
        draftInitDocuments.load.loadingIniziale = false;
      return draftInitDocuments;


      case actionTypes.SALVA_DOCUMENTI_TRASPARENZA:
        const draftDocumentiTrasparenza = {...state};
        draftDocumentiTrasparenza.documentiPdf.documentiTrasparenza = action.payload;
        return draftDocumentiTrasparenza;

      case actionTypes.INIT_UUID:
        const draftInitUuid = {...state};
        draftInitUuid.modello.id = action.payload;
        draftInitUuid.load.loadingIniziale = false;
      return draftInitUuid;

      case actionTypes.INIT_TOKEN_INBANK:
        const draftInitTokenInBank = {...state};
        draftInitTokenInBank.modello.codiceBroker = action.payload.cb;

        // Compilo i campi provenienti dal Token, solo se il token è valido
        if(action.payload.data) {
          Object.keys(draftInitTokenInBank.modello.datiPratica).forEach((chiaveStato) => {
            action.payload.data.forEach(item => {
              if(chiaveStato === item.field){
                draftInitTokenInBank.modello.datiPratica[`${chiaveStato}`] = item.value;
              }
            });
          });
          draftInitTokenInBank.datiTokenInBank = action.payload.data;
        }
        
        draftInitTokenInBank.load.loadingIniziale = false;
      return draftInitTokenInBank;

      case actionTypes.SALVA_CODICE_BROKER:
        const draftSalvaCodiceBroker = {...state};
        draftSalvaCodiceBroker.modello.codiceBroker = action.codice;
        draftSalvaCodiceBroker.load.loadingIniziale = false;
      return draftSalvaCodiceBroker;

      case actionTypes.SAVE_DATA:
        const draftSalvaDati = {...state};
        draftSalvaDati.modello = action.payload;
        // Se lo step corrente è 13 (caricamento carta identità) e la carta è già stata caricata,
        // porta l'utente allo step 15 (caricamento documenti secondari)
        if (draftSalvaDati.modello.currentStep === 13 && draftSalvaDati.modello.datiPratica && 
            (draftSalvaDati.modello.datiPratica.idCardUploaded === true || 
             draftSalvaDati.modello.datiPratica.documentoIdentitaCaricato === true)) {
          draftSalvaDati.modello.currentStep = 15;
        }
      return draftSalvaDati;

      case actionTypes.ERROR_SAVE_DATA:
        const draftErrorSaveData = {...state};
        draftErrorSaveData.salvaDatiIniziali.erroreControllo = true;
        draftErrorSaveData.salvaDatiIniziali.errorMessage = action.payload;
        if (Array.isArray(draftErrorSaveData.salvaDatiIniziali.errorMessage)) {
          draftErrorSaveData.salvaDatiIniziali.errorMessage.forEach(errore => {
            if(errore.errorCode === 'generico'){
              message.error(`Errore: ${errore.errorMessage}`,15);
            }
          });
        } else {
          message.error(`Errore: ${draftErrorSaveData.salvaDatiIniziali.errorMessage}`,15);
        }
      return draftErrorSaveData;

      case actionTypes.ERROR_SALVA_STEP:
        const draftErrorSalvaStep = {...state};
        draftErrorSalvaStep.salvaStep.dati = action.payload; 
          draftErrorSalvaStep.salvaStep.dati.forEach(errore => {
            if(errore.errorCode === 'generico'){
              message.error(`Errore: ${errore.errorMessage}`,15);
            }else{
              draftErrorSalvaStep.modello.datiPratica[`${errore.errorCode}`] = null;
            }
          });
      return draftErrorSalvaStep;

      case actionTypes.ERROR_UUIDGET:
        const draftErrorUuid = {...state};
        draftErrorUuid.erroreUuid.dati = action.payload;
      return draftErrorUuid;

      case actionTypes.ERROR_TOKENINBANK:
        const draftErrorTokeninbank = {...state};
        draftErrorTokeninbank.erroreTokeninbank.dati = action.payload;
      return draftErrorTokeninbank;

      case actionTypes.SALVA_DATI_GET_PREVENTIVO:
        const draftSetPreventivo = {...state};
        draftSetPreventivo.modello.datiPratica.importo = action.importo;
        draftSetPreventivo.modello.datiPratica.numeroRate = action.numeroRate;
        draftSetPreventivo.modello.codiceBroker = action.codice;
      return draftSetPreventivo;
        

        case actionTypes.SALVA_PREVENTIVO:
          const draftStatePreventivo = {...state};
          Object.keys(draftStatePreventivo.modello.datiPratica).forEach((chiaveStato) => {
            Object.entries(action.payload).forEach(([chiavePayload,valorePayload]) => {
              if(chiaveStato === chiavePayload){
                draftStatePreventivo.modello.datiPratica[`${chiaveStato}`] = valorePayload;
              }
            });
          })
        return draftStatePreventivo;

        case actionTypes.SALVA_DATI:
          const draftStateDati = {...state};
          Object.keys(draftStateDati.modello.datiPratica).forEach((chiaveStato) => {
            Object.entries(action.payload).forEach(([chiavePayload,valorePayload]) => {
              if(chiaveStato === chiavePayload){
                draftStateDati.modello.datiPratica[`${chiaveStato}`] = valorePayload;
              }
            });
          })
        return draftStateDati;


        case actionTypes.CAMBIO_CLIENTE_CCB:
          const draftCambioCorrentistaCcb = {...state};
          draftCambioCorrentistaCcb.modello.datiPratica.correntistaCcb = action.payload;
        return draftCambioCorrentistaCcb;

        case actionTypes.CHANGE_PRIVACY_CHECKBOX:
          const draftCambioPrivacyCheckbox = {...state};
          draftCambioPrivacyCheckbox.modello.datiPratica.informativaPrivacy = action.payload;
        return draftCambioPrivacyCheckbox;


        case actionTypes.SALVA_DOMANDA_QUESTIONARIO:
          const draftStateDomandeQuestionario = {...state};
          const numeroDomanda = action.numeroDomanda;
          const valoreDomanda = action.valoreDomanda;
          Object.keys(draftStateDomandeQuestionario.modello.datiPratica).forEach((chiaveStato) => {
            if(chiaveStato === numeroDomanda){
              draftStateDomandeQuestionario.modello.datiPratica[`${chiaveStato}`] = valoreDomanda;
            }
          })
        return draftStateDomandeQuestionario;


        case actionTypes.SALVA_QUESTIONARIO:
          const draftStateQuestionario = {...state};
            draftStateQuestionario.modello.datiPratica.questionarioCompletato = true;
        return draftStateQuestionario;






        case actionTypes.REMOVE_ASSICURAZIONE:
          const draftStateAssicurazione = {...state};
            draftStateAssicurazione.modello.datiPratica.assicurazione = action.payload;
            draftStateAssicurazione.modello.datiPratica.domanda1 = null;
            draftStateAssicurazione.modello.datiPratica.domanda2 = null;
            draftStateAssicurazione.modello.datiPratica.domanda3 = null;
            draftStateAssicurazione.modello.datiPratica.domanda4 = null;
            draftStateAssicurazione.modello.datiPratica.questionarioCompletato = null;
        return draftStateAssicurazione;

        case actionTypes.MODIFICA_STEP:
          const draftModificaStep = {...state};
          draftModificaStep.modello.currentStep = action.stepDiModifica;
        return draftModificaStep;

        case actionTypes.MODIFICA_PREVENTIVO:
          const draftModificaPreventivo = {...state};
          draftModificaPreventivo.tmpCurrentStep = draftModificaPreventivo.modello.currentStep;
          draftModificaPreventivo.modello.currentStep = action.stepDiModifica;
        return draftModificaPreventivo;






        case actionTypes.SALVA_DATI_CODICE_FISCALE:
          const draftDatiCF = {...state};
          draftDatiCF.datiCodiceFiscale.sesso = "";
          draftDatiCF.datiCodiceFiscale.comuneNascita ="";
          draftDatiCF.datiCodiceFiscale.provinciaNascita = "";
          draftDatiCF.datiCodiceFiscale.dataNascita = "";
          draftDatiCF.datiCodiceFiscale.errorCode = "";
          draftDatiCF.datiCodiceFiscale.errorMessage = "";

          Object.keys(draftDatiCF.modello.datiPratica).forEach((chiaveStato) => {
            Object.entries(action.payload).forEach(([chiavePayload,valorePayload]) => {
              if(chiaveStato === chiavePayload){
                draftDatiCF.modello.datiPratica[`${chiaveStato}`] = valorePayload;
              }
            });
          });

          draftDatiCF.datiCodiceFiscale = action.payload;
        return draftDatiCF;


        case actionTypes.CONTROLLO_TELEFONO_CELLULARE:
          const draftControlloTelefonoCellulare = {...state};
          draftControlloTelefonoCellulare.controlloTelefonoCellulare = action.payload;
        return draftControlloTelefonoCellulare;

        case actionTypes.SALVA_DATI_IBAN:
          const draftDatiIban = {...state};
          draftDatiIban.salvaStep.dati = null;
          draftDatiIban.modello.datiPratica.correntistaCcb = action.payload.correntistaCCB;
          draftDatiIban.datiIban = action.payload;
        return draftDatiIban;

        case actionTypes.CONTROLLO_CITTADINANZA:
          const draftControlloCittadinanza = {...state};
          draftControlloCittadinanza.modello.datiPratica.cittadinanza = action.cittadinanza;
          draftControlloCittadinanza.modello.datiPratica.tipoPermessoSoggiorno = null;
          draftControlloCittadinanza.modello.datiPratica.dataScadenzaSoggiorno = "";

          draftControlloCittadinanza.controlloCittadinanza = action.payload;
        return draftControlloCittadinanza;

        case actionTypes.CONTROLLO_ABITAZIONE_AFFITTO:
          const draftControlloAbitazione = {...state};
          draftControlloAbitazione.modello.datiPratica.abitazione = action.abitazione;
          draftControlloAbitazione.modello.datiPratica.importoAffitto = "";
        return draftControlloAbitazione;

        case actionTypes.CONTROLLO_RESIDENZA:
          const draftControlloResidenza = {...state};
          draftControlloResidenza.controlloResidenza.dati = action.payload;
          draftControlloResidenza.modello.datiPratica.comune = null;
          draftControlloResidenza.modello.datiPratica.provincia = null;
          draftControlloResidenza.controlloCap.errorCode = null;
          draftControlloResidenza.controlloCap.errorMessage = null;
        return draftControlloResidenza;

        case actionTypes.INIT_CONTROLLO_RESIDENZA:
          const draftInitControlloResidenza = {...state};
          draftInitControlloResidenza.controlloResidenza.dati = action.payload;
          draftInitControlloResidenza.controlloCap.errorCode = null;
          draftInitControlloResidenza.controlloCap.errorMessage = null;
        return draftInitControlloResidenza;

        case actionTypes.ERROR_CONTROLLO_CAP:
          const draftControlloCap = {...state};
          draftControlloCap.controlloCap = action.payload;
          draftControlloCap.controlloResidenza.dati = "";
        return draftControlloCap;

        case actionTypes.ERROR_CONTROLLO_CAP_PRECEDENTE:
          const draftControlloCapPrecedente = {...state};
          draftControlloCapPrecedente.controlloCap = action.payload;
          draftControlloCapPrecedente.controlloResidenzaPrecedente.dati = "";
        return draftControlloCapPrecedente;

        case actionTypes.ERROR_CONTROLLO_CAP_AZIENDA:
          const draftControlloCapAzienda = {...state};
          draftControlloCapAzienda.controlloCap = action.payload;
          draftControlloCapAzienda.controlloResidenzaAzienda.dati = "";
        return draftControlloCapAzienda;

        case actionTypes.CONTROLLO_RESIDENZA_PRECEDENTE:
          const draftControlloResidenzaPrecedente = {...state};
          draftControlloResidenzaPrecedente.controlloResidenzaPrecedente.dati = action.payload;
          draftControlloResidenzaPrecedente.modello.datiPratica.comunePrecedente = null;
          draftControlloResidenzaPrecedente.modello.datiPratica.provinciaPrecedente = null;
          draftControlloResidenzaPrecedente.controlloCap.errorCode = null;
          draftControlloResidenzaPrecedente.controlloCap.errorMessage = null;
        return draftControlloResidenzaPrecedente;

        case actionTypes.INIT_CONTROLLO_RESIDENZA_PRECEDENTE:
          const draftInitControlloResidenzaPrecedente = {...state};
          draftInitControlloResidenzaPrecedente.controlloResidenzaPrecedente.dati = action.payload;
          draftInitControlloResidenzaPrecedente.controlloCap.errorCode = null;
          draftInitControlloResidenzaPrecedente.controlloCap.errorMessage = null;
        return draftInitControlloResidenzaPrecedente;

        case actionTypes.CAP_RESIDENZA:
          const draftCapResidenza = {...state};
          draftCapResidenza.modello.datiPratica.cap = action.cap;
        return draftCapResidenza;

        case actionTypes.CAP_RESIDENZA_PRECEDENTE:
          const draftCapResidenzaPrecedente = {...state};
          draftCapResidenzaPrecedente.modello.datiPratica.capPrecedente = action.cap;
        return draftCapResidenzaPrecedente;

        case actionTypes.CAP_RESIDENZA_AZIENDA:
          const draftCapResidenzaAzienda = {...state};
          draftCapResidenzaAzienda.modello.datiPratica.capAzienda = action.cap;
        return draftCapResidenzaAzienda;


        case actionTypes.COMUNE_RESIDENZA:
          const draftComuneResidenza = {...state};
          draftComuneResidenza.modello.datiPratica.comune = action.comune;
        return draftComuneResidenza;

        case actionTypes.COMUNE_RESIDENZA_PRECEDENTE:
          const draftComuneResidenzaPrecedente = {...state};
          draftComuneResidenzaPrecedente.modello.datiPratica.comunePrecedente = action.comune;
        return draftComuneResidenzaPrecedente;

        case actionTypes.COMUNE_RESIDENZA_AZIENDA:
          const draftComuneResidenzaAzienda = {...state};
          draftComuneResidenzaAzienda.modello.datiPratica.comuneAzienda = action.comune;
        return draftComuneResidenzaAzienda;

        case actionTypes.CAMBIO_DOCUMENTO:
          const draftCambioDocumento = {...state};
          draftCambioDocumento.modello.datiPratica.documento = action.payload;
        return draftCambioDocumento;

        case actionTypes.PROVINCIA_DOCUMENTO_IDENTIFICATIVO:
          const draftCambioProvinciaDocumento = {...state};
          draftCambioProvinciaDocumento.modello.datiPratica.provinciaEmissione = action.provincia;
        return draftCambioProvinciaDocumento;

        case actionTypes.LISTA_PROVINCE_DOCUMENTO_IDENTIFICATIVO:
          const draftListaProvinceDocumento = {...state};
          draftListaProvinceDocumento.listaProvinceDocumento.dati = action.payload;
        return draftListaProvinceDocumento;

        case actionTypes.LISTA_COMUNI_DOCUMENTO_IDENTIFICATIVO:
          const draftListaComuniDocumento = {...state};
          draftListaComuniDocumento.listaComuniDocumento.dati = action.payload;
        return draftListaComuniDocumento;

        case actionTypes.CAMBIO_ATTIVITA:
          const draftCambioAttivita= {...state};
          draftCambioAttivita.modello.datiPratica.attivita = action.payload;
          draftCambioAttivita.modello.datiPratica.redditoMensilita = null;
          draftCambioAttivita.modello.datiPratica.occupazioneAutonomo = null;
          draftCambioAttivita.modello.datiPratica.occupazioneDipendente = null;
          draftCambioAttivita.modello.datiPratica.tipologiaPensione = null;
          draftCambioAttivita.modello.datiPratica.dataInizioAttivita = "";
          draftCambioAttivita.modello.datiPratica.dataFineAttivita = "";
          draftCambioAttivita.modello.datiPratica.settoreAttivita = null;
          draftCambioAttivita.modello.datiPratica.tipoContratto = null;
          draftCambioAttivita.modello.datiPratica.ragioneSocialeAzienda = "";
          draftCambioAttivita.modello.datiPratica.indirizzoResidenzaAzienda = "";
          draftCambioAttivita.modello.datiPratica.capAzienda = "";
          draftCambioAttivita.modello.datiPratica.comuneAzienda = null;
          draftCambioAttivita.modello.datiPratica.provinciaAzienda = null;
          draftCambioAttivita.modello.datiPratica.telefonoAzienda = "";
        return draftCambioAttivita;

        case actionTypes.CONTROLLO_RESIDENZA_AZIENDA:
          const draftControlloResidenzaAzienda = {...state};
          draftControlloResidenzaAzienda.controlloResidenzaAzienda.dati = action.payload;
          draftControlloResidenzaAzienda.modello.datiPratica.comuneAzienda = null;
          draftControlloResidenzaAzienda.modello.datiPratica.provinciaAzienda = null;
          draftControlloResidenzaAzienda.controlloCap.errorCode = null;
          draftControlloResidenzaAzienda.controlloCap.errorMessage = null;
        return draftControlloResidenzaAzienda;


        case actionTypes.INIT_CONTROLLO_RESIDENZA_AZIENDA:
          const draftInitControlloResidenzaAzienda = {...state};
          draftInitControlloResidenzaAzienda.controlloResidenzaAzienda.dati = action.payload;
          draftInitControlloResidenzaAzienda.controlloCap.errorCode = null;
          draftInitControlloResidenzaAzienda.controlloCap.errorMessage = null;
        return draftInitControlloResidenzaAzienda;





        // SERVIZI BE

        case actionTypes.CALCOLO_PREVENTIVO:
          const draftCalcoloPreventivo = {...state};

          draftCalcoloPreventivo.modello.datiPratica.tan = action.payload.tan;
          draftCalcoloPreventivo.modello.datiPratica.taeg = action.payload.taeg;
          draftCalcoloPreventivo.modello.datiPratica.rata = action.payload.importoRata;

          draftCalcoloPreventivo.modello.datiPratica.importo = action.importo;
          draftCalcoloPreventivo.modello.datiPratica.numeroRate = action.numeroRate;
          draftCalcoloPreventivo.modello.datiPratica.progetto = action.progetto;
          draftCalcoloPreventivo.modello.datiPratica.assicurazione = action.assicurazione;

          draftCalcoloPreventivo.modello.progressivoSimulazione = action.payload.progressivoSimulazione;

          if(!draftCalcoloPreventivo.modello.datiPratica.assicurazione){
            draftCalcoloPreventivo.modello.datiPratica.domanda1 = null;
            draftCalcoloPreventivo.modello.datiPratica.domanda2 = null;
            draftCalcoloPreventivo.modello.datiPratica.domanda3 = null;
            draftCalcoloPreventivo.modello.datiPratica.domanda4 = null;
            draftCalcoloPreventivo.modello.datiPratica.questionarioCompletato = null;
          }

          draftCalcoloPreventivo.errorePreventivo.dati = null;

        return draftCalcoloPreventivo;



        case actionTypes.ERROR_CALCOLO_PREVENTIVO:
          const draftErrorCalcoloPreventivo = {...state};
          draftErrorCalcoloPreventivo.errorePreventivo.dati = action.payload;
          if (typeof draftErrorCalcoloPreventivo.errorePreventivo.dati == "string") {
            message.error(`Errore: ${draftErrorCalcoloPreventivo.errorePreventivo.dati}`,15)
          } else {
            draftErrorCalcoloPreventivo.errorePreventivo.dati.forEach(errore => {
              if(errore.errorCode === 'generico'){
                message.error(`Errore: ${errore.errorMessage}`,15);
              }
            });
          }
        return draftErrorCalcoloPreventivo;


        case actionTypes.SALVA_DOCUMENTI:
          const draftSalvaDocumenti = {...state};
          draftSalvaDocumenti.documenti = action.payload;
        return draftSalvaDocumenti;









        case actionTypes.STEP_AVANTI:
          const draftStateStepAvanti = {...state};
          draftStateStepAvanti.salvaStep.dati = null;
          if(draftStateStepAvanti.tmpCurrentStep === 0){
              if(draftStateStepAvanti.modello.currentStep === 15){  // it should become 15
                return draftStateStepAvanti;
              }else if(
                draftStateStepAvanti.modello.currentStep === 5 ||
                (draftStateStepAvanti.modello.currentStep === 10 &&
                  ( draftStateStepAvanti.modello.datiPratica.questionarioCompletato === true ||  draftStateStepAvanti.modello.datiPratica.assicurazione === false )
                )/*  ||
                (draftStateStepAvanti.modello.currentStep === 12 &&
                  ( draftStateStepAvanti.modello.datiPratica.questionarioCompletato === true ||  draftStateStepAvanti.modello.datiPratica.assicurazione === false )
                ) */
              ){
                draftStateStepAvanti.modello.currentStep += 2;
                return draftStateStepAvanti;
              }else{
                draftStateStepAvanti.modello.currentStep += 1;
                return draftStateStepAvanti;
              }

          }else{
            draftStateStepAvanti.modello.currentStep = draftStateStepAvanti.tmpCurrentStep;
            draftStateStepAvanti.tmpCurrentStep = 0;
            return draftStateStepAvanti;
          }
          

        case actionTypes.STEP_INDIETRO:
          const draftStateStepIndietro = {...state};
              if(draftStateStepIndietro.modello.currentStep === 0){
                return draftStateStepIndietro;
              }else{
                
                // Se sei al riepilogo (step 12) e torni indietro, skippa il questionario (step 11) se non hai assicurazione
                if(draftStateStepIndietro.modello.currentStep === 12 && 
                   (draftStateStepIndietro.modello.datiPratica.questionarioCompletato === true || 
                    draftStateStepIndietro.modello.datiPratica.assicurazione === false)){
                  draftStateStepIndietro.salvaStep.dati = null;
                  draftStateStepIndietro.modello.currentStep -= 2;
                  return draftStateStepIndietro;
                }
                
                if(draftStateStepIndietro.modello.currentStep === 9){
                  if(draftStateStepIndietro.modello.datiPratica.capAzienda === null || draftStateStepIndietro.modello.datiPratica.comuneAzienda === null || draftStateStepIndietro.modello.datiPratica.provinciaAzienda === null){
                    draftStateStepIndietro.modello.datiPratica.indirizzoResidenzaAzienda = null;
                    draftStateStepIndietro.modello.datiPratica.capAzienda=null;
                    draftStateStepIndietro.modello.datiPratica.comuneAzienda=null;
                    draftStateStepIndietro.modello.datiPratica.provinciaAzienda=null;
                  }
                }

                if(draftStateStepIndietro.modello.currentStep === 7){
                  if(draftStateStepIndietro.modello.datiPratica.cap === null || draftStateStepIndietro.modello.datiPratica.comune === null || draftStateStepIndietro.modello.datiPratica.provincia === null){
                    draftStateStepIndietro.modello.datiPratica.cap=null;
                    draftStateStepIndietro.modello.datiPratica.comune=null;
                    draftStateStepIndietro.modello.datiPratica.provincia=null;
                  }
                  
                  if(draftStateStepIndietro.modello.datiPratica.capPrecedente === null || draftStateStepIndietro.modello.datiPratica.comunePrecedente === null || draftStateStepIndietro.modello.datiPratica.provinciaPrecedente === null){
                    draftStateStepIndietro.modello.datiPratica.indirizzoResidenzaPrecedente=null;
                    draftStateStepIndietro.modello.datiPratica.civicoPrecedente=null;
                    //draftStateStepIndietro.modello.datiPratica.tempoResidenza=null;
                    draftStateStepIndietro.modello.datiPratica.capPrecedente=null;
                    draftStateStepIndietro.modello.datiPratica.comunePrecedente=null;
                    draftStateStepIndietro.modello.datiPratica.provinciaPrecedente=null;
                  }
                }

                draftStateStepIndietro.salvaStep.dati = null;
                draftStateStepIndietro.modello.currentStep -= 1;
                return draftStateStepIndietro;
              }
        
        case actionTypes.STEP_INDIETRO_SKIP:
          const draftStateStepIndietroSkip = {...state};
            // if(draftStateStepIndietroSkip.modello.currentStep === 0){
            //   return draftStateStepIndietroSkip;
            // }else{
            //   if(draftStateStepIndietroSkip.modello.currentStep === 9){
            //     if(draftStateStepIndietroSkip.modello.datiPratica.capAzienda === null || draftStateStepIndietroSkip.modello.datiPratica.comuneAzienda === null || draftStateStepIndietroSkip.modello.datiPratica.provinciaAzienda === null){
            //       draftStateStepIndietroSkip.modello.datiPratica.indirizzoResidenzaAzienda = null;
            //       draftStateStepIndietroSkip.modello.datiPratica.capAzienda=null;
            //       draftStateStepIndietroSkip.modello.datiPratica.comuneAzienda=null;
            //       draftStateStepIndietroSkip.modello.datiPratica.provinciaAzienda=null;
            //     }
            //   }
              if(draftStateStepIndietroSkip.modello.currentStep === 7){
                if(draftStateStepIndietroSkip.modello.datiPratica.cap === null || draftStateStepIndietroSkip.modello.datiPratica.comune === null || draftStateStepIndietroSkip.modello.datiPratica.provincia === null){
                  draftStateStepIndietroSkip.modello.datiPratica.cap=null;
                  draftStateStepIndietroSkip.modello.datiPratica.comune=null;
                  draftStateStepIndietroSkip.modello.datiPratica.provincia=null;
                }
                if(draftStateStepIndietroSkip.modello.datiPratica.capPrecedente === null || draftStateStepIndietroSkip.modello.datiPratica.comunePrecedente === null || draftStateStepIndietroSkip.modello.datiPratica.provinciaPrecedente === null){
                  draftStateStepIndietroSkip.modello.datiPratica.indirizzoResidenzaPrecedente=null;
                  draftStateStepIndietroSkip.modello.datiPratica.civicoPrecedente=null;
                  //draftStateStepIndietroSkip.modello.datiPratica.tempoResidenza=null;
                  draftStateStepIndietroSkip.modello.datiPratica.capPrecedente=null;
                  draftStateStepIndietroSkip.modello.datiPratica.comunePrecedente=null;
                  draftStateStepIndietroSkip.modello.datiPratica.provinciaPrecedente=null;
                }
              }
              draftStateStepIndietroSkip.salvaStep.dati = null;
              draftStateStepIndietroSkip.modello.currentStep -= 2;
              return draftStateStepIndietroSkip;
          // }

        case actionTypes.STEP_SECONDARY_DOCUMENTS:
          const draftStateStepSecondaryDocuments = {...state};
          draftStateStepSecondaryDocuments.modello.currentStep = 15;
          return draftStateStepSecondaryDocuments;


        case actionTypes.STEP_AVANTI_CONFERMA:
          const draftStateStepAvanti2Volte = {...state};
            draftStateStepAvanti2Volte.modello.currentStep = 14;
          return draftStateStepAvanti2Volte;
        
        case actionTypes.STEP_AVANTI_FINE:
          const draftStateStepAvantiFine = {...state};
          draftStateStepAvantiFine.modello.currentStep = 16;
          return draftStateStepAvantiFine;


        case actionTypes.LOADING_INIZIALE_TRUE:
          const draftLoadingInizialeTrue = {...state};
          draftLoadingInizialeTrue.load.loadingIniziale = true;
        return draftLoadingInizialeTrue;
  
        case actionTypes.LOADING_INIZIALE_FALSE:
          const draftLoadingInizialeFalse = {...state};
          draftLoadingInizialeFalse.load.loadingIniziale = false;
        return draftLoadingInizialeFalse;

        case actionTypes.LOADING_TRUE:
          const draftLoadingTrue = {...state};
          draftLoadingTrue.load.loadingStep = true;
        return draftLoadingTrue;

        case actionTypes.LOADING_FALSE:
          const draftLoadingFalse = {...state};
          draftLoadingFalse.load.loadingStep = false;
        return draftLoadingFalse;

        case actionTypes.LOADING_PREVENTIVO_TRUE:
          const draftLoadingPreventivoTrue = {...state};
          draftLoadingPreventivoTrue.load.loadingPreventivo = true;
        return draftLoadingPreventivoTrue;

        case actionTypes.LOADING_PREVENTIVO_FALSE:
          const draftLoadingPreventivoFalse = {...state};
          draftLoadingPreventivoFalse.load.loadingPreventivo = false;
        return draftLoadingPreventivoFalse;

        case actionTypes.LOADING_CF_TRUE:
          const draftLoadingCfTrue = {...state};
          draftLoadingCfTrue.load.loadingCodiceFiscale = true;
        return draftLoadingCfTrue;
  
        case actionTypes.LOADING_CF_FALSE:
          const draftLoadingCfFalse = {...state};
          draftLoadingCfFalse.load.loadingCodiceFiscale = false;
        return draftLoadingCfFalse;


        case actionTypes.LOADING_COMUNI_TRUE:
          const draftLoadingComuniTrue = {...state};
          draftLoadingComuniTrue.load.loadingComuni = true;
        return draftLoadingComuniTrue;
  
        case actionTypes.LOADING_COMUNI_FALSE:
          const draftLoadingComuniFalse = {...state};
          draftLoadingComuniFalse.load.loadingComuni = false;
        return draftLoadingComuniFalse;


        case actionTypes.LOADING_PROVINCE_TRUE:
          const draftLoadingProvinceTrue = {...state};
          draftLoadingProvinceTrue.load.loadingProvince = true;
        return draftLoadingProvinceTrue;
  
        case actionTypes.LOADING_PROVINCE_FALSE:
          const draftLoadingProvinceFalse = {...state};
          draftLoadingProvinceFalse.load.loadingProvince = false;
        return draftLoadingProvinceFalse;



        case actionTypes.LOADING_CONFERMA_TRUE:
          const draftLoadingConfermaTrue = {...state};
          draftLoadingConfermaTrue.load.loadingConferma = true;
        return draftLoadingConfermaTrue;
  
        case actionTypes.LOADING_CONFERMA_FALSE:
          const draftLoadingConfermaFalse = {...state};
          draftLoadingConfermaFalse.load.loadingConferma = false;
        return draftLoadingConfermaFalse;


        case actionTypes.LOADING_RESIDENZA_TRUE:
          const draftLoadingResidenzaTrue = {...state};
          draftLoadingResidenzaTrue.load.loadingResidenza = true;
        return draftLoadingResidenzaTrue;
  
        case actionTypes.LOADING_RESIDENZA_FALSE:
          const draftLoadingResidenzaFalse = {...state};
          draftLoadingResidenzaFalse.load.loadingResidenza = false;
        return draftLoadingResidenzaFalse;

        case actionTypes.LOADING_RESIDENZA_PRECEDENTE_TRUE:
          const draftLoadingResidenzaPrecedenteTrue = {...state};
          draftLoadingResidenzaPrecedenteTrue.load.loadingResidenzaPrecedente = true;
        return draftLoadingResidenzaPrecedenteTrue;
  
        case actionTypes.LOADING_RESIDENZA_PRECEDENTE_FALSE:
          const draftLoadingResidenzaPrecedenteFalse = {...state};
          draftLoadingResidenzaPrecedenteFalse.load.loadingResidenzaPrecedente = false;
        return draftLoadingResidenzaPrecedenteFalse;

        case actionTypes.LOADING_RESIDENZA_AZIENDA_TRUE:
          const draftLoadingResidenzaAziendaTrue = {...state};
          draftLoadingResidenzaAziendaTrue.load.loadingResidenzaAzienda = true;
        return draftLoadingResidenzaAziendaTrue;
  
        case actionTypes.LOADING_RESIDENZA_AZIENDA_FALSE:
          const draftLoadingResidenzaAziendaFalse = {...state};
          draftLoadingResidenzaAziendaFalse.load.loadingResidenzaAzienda = false;
        return draftLoadingResidenzaAziendaFalse;


        case actionTypes.LOADING_UUIDGET_TRUE:
          const draftLoadingUuidTrue = {...state};
          draftLoadingUuidTrue.load.loadingUuidGet = true;
        return draftLoadingUuidTrue;
  
        case actionTypes.LOADING_UUIDGET_FALSE:
          const draftLoadingUuidFalse = {...state};
          draftLoadingUuidFalse.load.loadingUuidGet = false;
        return draftLoadingUuidFalse;


        case actionTypes.UPLOADING_ID_DOC_TRUE:
          const draftUploadingIdDocTrue = {...state};
          draftUploadingIdDocTrue.load.idDocUploaded = true;
        return draftUploadingIdDocTrue;
  
        case actionTypes.UPLOADING_ID_DOC_FALSE:
          const draftUploadingIdDocFalse = {...state};
          draftUploadingIdDocFalse.load.idDocUploaded = false;
        return draftUploadingIdDocFalse;


        case actionTypes.UPLOADING_HEALTH_DOC_TRUE:
          const draftUploadingHealthDocTrue = {...state};
          draftUploadingHealthDocTrue.load.healthDocUploaded = true;
        return draftUploadingHealthDocTrue;
  
        case actionTypes.UPLOADING_HEALTH_DOC_FALSE:
          const draftUploadingHealthDocFalse = {...state};
          draftUploadingHealthDocFalse.load.healthDocUploaded = false;
        return draftUploadingHealthDocFalse;


        case actionTypes.UPLOADING_INCOME_DOC_TRUE:
          const draftUploadingIncomeDocTrue = {...state};
          draftUploadingIncomeDocTrue.load.incomeDocUploaded = true;
        return draftUploadingIncomeDocTrue;
  
        case actionTypes.UPLOADING_INCOME_DOC_FALSE:
          const draftUploadingIncomeDocFalse = {...state};
          draftUploadingIncomeDocFalse.load.incomeDocUploaded = false;
        return draftUploadingIncomeDocFalse;
          

      default:
        return state;
    }
  };

  export default dataReducer;